__turbopack_context__.v({
  "component": "style-module-scss-module__Xc6jdq__component",
  "date": "style-module-scss-module__Xc6jdq__date",
  "excerpt": "style-module-scss-module__Xc6jdq__excerpt",
  "featured-card": "style-module-scss-module__Xc6jdq__featured-card",
  "image-wrapper": "style-module-scss-module__Xc6jdq__image-wrapper",
  "text-section": "style-module-scss-module__Xc6jdq__text-section",
  "title": "style-module-scss-module__Xc6jdq__title",
  "top-label": "style-module-scss-module__Xc6jdq__top-label",
});
